import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { InputLabel } from "@mui/material";
import { useOptions } from "components/hooks/useOptions";
import styles from "./styles.module.scss"
import { combineClasses } from "utils/utils";

export default function CustomAsyncAutoComplete({
    width,
    height,
    label,
    isRequired = false,
    placeholder,
    onBlur,
    setSelectedOption,
    errorMessage = "",
    defaultValue = {
        label: "",
        value: ""
    },
    name = "default",
    customStyles = {},
    endpoint,
    dataCb,
    wrapperClasss,
    sx = {},
    autoFocus = false,
    fullWidth=false,
    isValidate=false,
    ...rest
}) {
    const [value, setValue] = useState(defaultValue?.value ? defaultValue : null)
    const { onHandleOpenChange, onSearchInputValueChange, isLoading, isError, options, isOpen } = useOptions(endpoint, dataCb);
    const onSelectedOptionChange = (event, newValue) => {
        setSelectedOption(newValue)
        setValue(newValue)
    };

    const handleMouseLeave = () => {
        onHandleOpenChange(false); // Close the dropdown when mouse leaves the options container
    };
    return (
        <div
            className={combineClasses(styles.wrapperClasss, wrapperClasss, fullWidth ? styles.fullWidth : "")}
            style={sx}
        >
            {label ? (
                <InputLabel
                    sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "5px" }}
                >
                    {label} {isRequired && <span style={{ color: "red" }}>*</span>}
                </InputLabel>
            ) : null}

            <Autocomplete
                sx={{
                    width,
                    height,
                    marginTop: "5px !important",
                    "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                    },
                    "& .MuiAutocomplete-input": {
                        fontSize: "14px",
                    },
                    "& .MuiFormHelperText-root": {
                        margin: 0,
                    },
                    ...customStyles
                }}
                fullWidth={fullWidth}
                size="small"
                open={isOpen}
                name={name}
                onBlur={onBlur}
                value={value}
                onChange={onSelectedOptionChange}
                onInputChange={onSearchInputValueChange}
                onOpen={() => onHandleOpenChange(true)}
                onClose={() => onHandleOpenChange(false)}
                defaultValue={defaultValue}
                autoComplete
                isOptionEqualToValue={(option, value) => {
                    return option?.value === value?.value;
                }}
                getOptionLabel={(option) => {
                    return option?.label;
                }}
                renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                        <li key={option?.value} {...optionProps}>
                            {option?.label}
                        </li>
                    );
                }}
                options={options || []}
                loading={isLoading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={isOpen ? "Search" : label || placeholder}
                        error={(Boolean(isError) || Boolean(isValidate))}
                        helperText={(Boolean(isError) || Boolean(isValidate)) && errorMessage}
                        onBlur={onBlur}
                        name={name}
                        autoFocus={autoFocus}
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {isLoading ? (
                                            <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            },
                        }}
                    />
                )}
                // Add mouse leave detection for options container
                ListboxProps={{
                    onMouseLeave: handleMouseLeave,
                }}
                {...rest}
            />
        </div>
    );
}
